import { FETCH_BATTLE_CARD_MP_FAILURE, FETCH_BATTLE_CARD_MP_REQUEST, FETCH_BATTLE_CARD_MP_SUCCESS } from "../../actions/meetingPrep/battleCardActions";

  const initialState = {
    battleCardLoading: false,
    battleCardMpData: [],
    battleCardError: null,
  };
  
  const battleCardMpReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BATTLE_CARD_MP_REQUEST:
        return { ...state, battleCardLoading: true , payload: action.payload};
      case FETCH_BATTLE_CARD_MP_SUCCESS:
        return { ...state, battleCardLoading: false, battleCardMpData: action.payload };
      case FETCH_BATTLE_CARD_MP_FAILURE:
        return { ...state, battleCardLoading: false, battleCardError: action.payload };       
      default:
        return state;
    }
  };
  
  export default battleCardMpReducer;
  